// Saasfuture.jsx
import React, { useEffect, useRef, useState } from "react";
import "../Style/Saasfuture.css";

import iconUser from "../assets/A.png";
import iconWireframe from "../assets/M.png";
import iconModernUI from "../assets/C.png";
import iconMobile from "../assets/A.png";
import iconUsability from "../assets/S.png";

const services = [
  {
    id: 1,
    icon: iconUser,
    title: "AI-Powered SaaS Platforms",
    text: "Integrate artificial intelligence and machine learning into your SaaS product to automate processes, personalize user experiences, and deliver smarter business insights.",
    row: "top",
  },
  {
    id: 2,
    icon: iconWireframe,
    title: "Multi-Tenant Architecture",
    text: "Develop scalable SaaS applications with secure multi-tenant architecture that supports multiple customers while maintaining performance, reliability, and data isolation.",
    row: "top",
  },
  {
    id: 3,
    icon: iconModernUI,
    title: "Cloud-Native Infrastructure",
    text: "Build cloud-first SaaS applications designed for high availability, seamless scalability, and optimized performance across global markets.",
    row: "top",
  },
  {
    id: 4,
    icon: iconMobile,
    title: "Advanced SaaS Security",
    text: "Protect your SaaS platform with enterprise-grade security, encrypted data storage, secure authentication, compliance standards, and continuous threat monitoring.",
    row: "bottom-left",
  },
  {
    id: 5,
    icon: iconUsability,
    title: "Exceptional User Experience",
    text: "Create intuitive SaaS applications with modern UI/UX design, faster workflows, responsive interfaces, and seamless user journeys that improve customer retention.",
    row: "bottom-right",
  },
];

const Saasfuture = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.12 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className={`saasfuture-main-section ${isVisible ? "saasfuture-visible" : ""}`}
      ref={sectionRef}
    >
      <div className="saasfuture-glow saasfuture-glow-1" aria-hidden="true" />
      <div className="saasfuture-glow saasfuture-glow-2" aria-hidden="true" />

      <div className="saasfuture-main-container">
        <span className="saasfuture-eyebrow saasfuture-anim saasfuture-anim-0">
          Our Approach
        </span>

        <h1 className="saasfuture-main-title saasfuture-anim saasfuture-anim-1">
          The Future of SaaS Development
        </h1>

        <p className="saasfuture-subtitle-label saasfuture-anim saasfuture-anim-2">
          Built for Tomorrow with MPeoples
        </p>

        <p className="saasfuture-main-description saasfuture-anim saasfuture-anim-3">
          Modern SaaS platforms are transforming how businesses operate by
          combining cloud technology, automation, and intelligent software. At
          MPeoples, we develop secure, scalable, and future-ready SaaS
          solutions that improve productivity, streamline operations, and
          accelerate business growth.
        </p>

        <div className="saasfuture-card-grid">
          {/* TOP ROW */}
          {services
            .filter((s) => s.row === "top")
            .map((service, i) => (
              <Card
                key={service.id}
                service={service}
                animClass={`saasfuture-anim saasfuture-anim-${4 + i}`}
              />
            ))}

          {/* BOTTOM ROW */}
          {services
            .filter((s) => s.row !== "top")
            .map((service, i) => (
              <Card
                key={service.id}
                service={service}
                extraClass={
                  service.row === "bottom-left"
                    ? "saasfuture-card-bottom-left"
                    : "saasfuture-card-bottom-right"
                }
                animClass={`saasfuture-anim saasfuture-anim-${7 + i}`}
              />
            ))}
        </div>
      </div>
    </section>
  );
};

const Card = ({ service, extraClass, animClass }) => (
  <div className={`saasfuture-service-card ${extraClass || ""} ${animClass || ""}`}>
    <div className="saasfuture-card-header">
      <div className="saasfuture-card-icon-wrap">
        <img src={service.icon} alt={service.title} className="saasfuture-card-icon" />
      </div>
      <h3 className="saasfuture-card-title">{service.title}</h3>
    </div>
    <p className="saasfuture-card-text">{service.text}</p>
  </div>
);

export default Saasfuture;